import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { FloatingWhatsApp } from '@/components/FloatingWhatsApp';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const BookingPage = () => {
  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Book a Free Consultation | MARKETYZE</title>
        <meta name="description" content="Book a free no-obligation consultation with a former Google specialist to discuss your Google Ads, Tag Manager, and Analytics needs." />
        <link rel="canonical" href="https://marketyze.eu/booking" />
        <meta property="og:title" content="Book a Free Consultation | MARKETYZE" />
        <meta property="og:url" content="https://marketyze.eu/booking" />
        <meta name="twitter:title" content="Book a Free Consultation | MARKETYZE" />
        <meta name="twitter:description" content="Book a free no-obligation consultation with a former Google specialist to discuss your Google Ads, Tag Manager, and Analytics needs." />
      </Helmet>
      <Navbar />
      
      <main className="pt-20 pb-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Back Button */}
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-8"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Link>

          {/* Header */}
          <div className="text-center mb-10">
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-foreground mb-4">
              Book Your <span className="text-[#34A853]">Free Consultation</span>
            </h1>
            <p className="text-muted-foreground leading-relaxed max-w-2xl mx-auto">
              Schedule a no-obligation call to discuss your Google Ads, Tag Manager, and Analytics needs. 
              Get expert insights from a former Google specialist.
            </p>
          </div>

          {/* Calendly Widget */}
          <Card className="bg-card border-border/50 shadow-lg overflow-hidden">
            <CardContent className="p-0">
              {/* Calendly inline widget */}
              <div 
                className="calendly-inline-widget" 
                data-url="https://calendly.com/tagbybelle/consultation"
                style={{ minWidth: '320px', height: '700px' }}
              />
            </CardContent>
          </Card>
        </div>
      </main>

      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default BookingPage;
